/**
 * Created by edison on 2017/3/5.
 * 定义两个存取localStorage的方法
 */
// 当前项目下的缓存全部使用WSH5命名空间

// saveType 取值 session || local

const saveToLocal = (saveType, key, value) => {
  let store = saveType === 'session' ? window.sessionStorage : window.localStorage
  let WSH5 = store.__WSH5__
  if (!WSH5) {
    WSH5 = {}
    WSH5[key] = value
  } else {
    WSH5 = JSON.parse(WSH5)
    // if (!WSH5[id]) {
    //   WSH5[id] = {}
    // }
  }
  WSH5[key] = value
  store.__WSH5__ = JSON.stringify(WSH5)
}
// def 为默认数据
const getFromLocal = (saveType, key, def) => {
  let store = saveType === 'session' ? window.sessionStorage : window.localStorage
  let WSH5 = store.__WSH5__
  if (!WSH5) {
    return def
  }
  WSH5 = JSON.parse(WSH5)
  if (WSH5[key] === 'undefined' || WSH5[key] === 'null') {
    return def
  }
  return WSH5[key] || def
}
export {
  saveToLocal,
  getFromLocal
}
